import Switch from '@mui/material/Switch';
import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';

const SwitchComponent = ({
  formik,
  property,
  switchHandler,
  sx = {},
  ...other
  /* disabled */
}) => {
  /*  const switchHandler = useCallback((e) => {
    const value = e.target.checked ? 1 : 0;
    formik.setFieldValue(property, value);
  }, []); */

  return (
    <FormControlLabel
      sx={{ ...sx }}
      {...other}
      control={
        <Switch
          onChange={switchHandler}
          name={property}
          /* disabled={disabled} */
          checked={!!formik.values[property]}
        />
      }
    />
  );
};

export default React.memo(
  SwitchComponent,
  (prevProps, nextProps) =>
    prevProps.formik.values[prevProps.property] ===
    nextProps.formik.values[nextProps.property],
);
